import { withInstall } from '../../../../utils/with-install'
import RoadNet from './RoadNet.vue'

export const ElAmapLayerRoadNet = withInstall(RoadNet)
export default ElAmapLayerRoadNet
